import {useEffect} from 'react';
interface SetCityAndStateProps {
  provinces?: Array<IProvince>;
  lab?: ILabAddInfo;
  setSelectedCities: (value: Array<ICity>) => void;
  setSelectedStates: (value: Array<Omit<IProvince, 'cities'>>) => void;
}
const useSetCityAndState = ({
  provinces,
  lab,
  setSelectedCities,
  setSelectedStates,
}: SetCityAndStateProps) => {
  useEffect(() => {
    const selectedProvinces =
      provinces?.filter(arr =>
        lab?.activity_state?.map(item => item.id).includes(arr.id),
      ) || [];
    setSelectedStates(selectedProvinces);
    setSelectedCities(
      selectedProvinces
        .map(item => item.cities)
        .flat()
        .filter(arr =>
          lab?.activity_city?.map(item => item.id).includes(arr.id),
        ),
    );
  }, [
    lab?.activity_city,
    lab?.activity_state,
    provinces,
    setSelectedCities,
    setSelectedStates,
  ]);
};

export default useSetCityAndState;
